import { useIntl } from 'react-intl';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { trackEvent } from '@/shared/lib';

import { ModalID, modalModel } from '@/entities/modal';
import { reportsModel } from '@/entities/reports';

export const useSignReport = (allTeethIsApproved = false) => {
  const dispatch = useAppDispatch();

  const { formatMessage } = useIntl();

  const reportID = useAppSelector(reportsModel.selectors.selectCurrentReportID);

  const title = allTeethIsApproved
    ? formatMessage({
        id: 'report.signReport',
        defaultMessage: 'Sign the report',
      })
    : formatMessage({
        id: 'consfirmSignReportModal.approveAll',
        defaultMessage: 'Approve all teeth',
      });

  const description = allTeethIsApproved
    ? formatMessage({
        id: 'report.warning.sign',
        defaultMessage: 'Are you sure you want to sign the report?',
      })
    : formatMessage({
        id: 'report.warning.approveAndSign',
        defaultMessage:
          'Are you sure you want to approve all the teeth and include in the report?',
      });

  const okText = allTeethIsApproved
    ? formatMessage({
        id: 'report.confirm.sign',
        defaultMessage: 'Yes, sign',
      })
    : formatMessage({
        id: 'report.confirm.approveAndSign',
        defaultMessage: 'Yes, approve all and sign',
      });

  return () => {
    dispatch(
      modalModel.actions.openModal({
        modalID: ModalID.Confirm,
        data: {
          title,
          description,
          okText,
          onConfirm: async () => {
            // TODO: [8|m] Find a way to incapsulate loading status management inside <ConfirmModal />
            dispatch(modalModel.actions.setConfirmModalLoading(true));
            try {
              await dispatch(
                reportsModel.thunks.approveAllTeethAndSignReport(
                  reportID as string,
                ),
              );
            } finally {
              trackEvent({
                eventName: allTeethIsApproved
                  ? 'ReportPageSignReportButtonClicked'
                  : 'ReportPageFooterApproveAndSignButtonClicked',
              });

              dispatch(modalModel.actions.setConfirmModalLoading(false));
              dispatch(modalModel.actions.closeModal(ModalID.Confirm));
            }
          },
        },
      }),
    );
  };
};
